export { default as InternalLink } from './InternalLink';
